import { createUserManager } from 'redux-oidc';

const UserManagerConfig = {
    client_id: '896d5421-4a83-4eb0-a014-f5f277d4844b', //ACP SSO
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/userlogin`,
    response_type: 'token',
    scope: '4ff5d762-3504-4b59-b57f-2f7c2625965a/user.impersonation.scope',
    authority: 'https://login.microsoftonline.com/b86fc8d6-e233-45de-9c12-eae1dcebfb56/v2.0/.well-known/openid-configuration',
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silentrenew`,
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: false,
    revokeAccessTokenOnSignout: true,
    silentRequestTimeout: 100000,
    accessTokenExpiringNotificationTime: 300
};

const _UserManager = createUserManager(UserManagerConfig);

export default _UserManager;
